import React from 'react';
import ChartErrorBoundary from '../common/ChartErrorBoundary';
import CampaignPerformanceChart from './CampaignPerformanceChart';
import PlatformDistributionChart from './PlatformDistributionChart';
import EngagementTrendChart from './EngagementTrendChart';
import type { CampaignPerformanceDataPoint, PlatformDistributionItem } from '../../types/analytics.types';

export interface AnalyticsChartsGridProps {
  campaignPerformance: CampaignPerformanceDataPoint[];
  performanceLoading: boolean;
  performanceError: boolean;
  onRetryPerformance: () => void;
  platformDistribution: PlatformDistributionItem[];
  platformLoading: boolean;
  platformError: boolean;
  onRetryPlatform: () => void;
  totalViews: number;
}

export const AnalyticsChartsGrid: React.FC<AnalyticsChartsGridProps> = ({
  campaignPerformance,
  performanceLoading,
  performanceError,
  onRetryPerformance,
  platformDistribution,
  platformLoading,
  platformError,
  onRetryPlatform,
  totalViews,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Campaign Performance Chart */}
        <div className="lg:col-span-2">
          <ChartErrorBoundary title="Campaign Performance">
            <CampaignPerformanceChart
              data={campaignPerformance}
              isLoading={performanceLoading}
              isError={performanceError}
              onRetry={onRetryPerformance}
            />
          </ChartErrorBoundary>
        </div>

        {/* Platform Distribution */}
        <ChartErrorBoundary title="Platform Distribution">
          <PlatformDistributionChart
            data={platformDistribution}
            totalViews={totalViews}
            isLoading={platformLoading}
            isError={platformError}
            onRetry={onRetryPlatform}
          />
        </ChartErrorBoundary>
      </div>

      {/* Engagement Rate Trend */}
      <ChartErrorBoundary title="Engagement Rate Trend">
        <EngagementTrendChart data={campaignPerformance} />
      </ChartErrorBoundary>
    </>
  );
};

export default AnalyticsChartsGrid;
